export default __webpack_public_path__ + "static/media/life-icon.e8d5cdcd.svg";